import React, { useState } from "react";
import "./Input.css";
import NumberFormat from "react-number-format";

class Input extends React.Component {
  state = {
    username: "",
    symbol: "&#8377;",
  };

  onChangeInput = (e) => {
    this.setState({ username: e.target.value });
  };

  cameraFile = (attributes) => {
    return (
      <div class="divButton">
        {attributes?.placeholder
          ? attributes.placeholder
          : "Click here to select your files"}
        <input
          type={attributes.type}
          className={`form-control inputCustom ${attributes.className ? attributes.className : ""
            } ${attributes.errorClass ? "is-invalid" : ""} `}
          name={attributes.name}
          disabled={attributes.disabled}
          value={attributes.value}
          onChange={attributes.onChange}
        />
      </div>
    );
  };

  render() {
    const attributes = this.props;

    return (
      <div className="form-group input-container">
        <div
          className={`${attributes?.showSymbol && attributes?.symbolPosition == "right"
              ? "input-icon-right"
              : "input-icon"
            }`}
        >
          {attributes?.faClass
            ? attributes?.showSymbol &&
            attributes?.value && (
              <i className={`fa ${attributes?.faClass}`}></i>
            )
            : attributes?.showSymbol &&
            attributes?.value && (
              <i>
                <b>{attributes?.symbol}</b>
              </i>
            )}
          {attributes.type === "textarea" ? (
            <textarea
              className={`form-control ${attributes.errorClass ? "is-invalid" : ""
                }  ${attributes.className ? attributes.className : ""} ${attributes.type == "file" ? "file" : ""
                }`}
              name={attributes.name}
              disabled={attributes.disabled}
              value={attributes.value}
              onChange={attributes.onChange}
              rows={attributes?.rows}
            />
          ) : attributes.type === "file" ? (
            attributes?.native ? (
              <div className="divFileContainer">
                <div className="divButton">
                  {attributes?.placeholder
                    ? attributes.placeholder
                    : "Click here to select your files"}{" "}
                </div>
                <input
                  type={attributes.type}
                  className={`form-control ${attributes.errorClass ? "is-invalid" : ""
                    }  ${attributes?.native && "fileUpload"} inputCustom ${attributes.className ? attributes.className : ""
                    }  file`}
                  name={attributes.name}
                  disabled={attributes.disabled}
                  multiple={attributes?.multiple}
                  value={attributes.value}
                  capture={attributes?.capture}
                  accept={attributes.accept}
                  onChange={attributes.onChange}
                />
              </div>
            ) : (
              <input
                type={attributes.type}
                className={`form-control ${attributes.errorClass ? "is-invalid" : ""
                  }  ${attributes?.native && "fileUpload"} inputCustom ${attributes.className ? attributes.className : ""
                  }  file`}
                name={attributes.name}
                disabled={attributes.disabled}
                multiple={attributes?.multiple}
                value={attributes.value}
                capture={attributes?.capture}
                accept={attributes.accept}
                onChange={attributes.onChange}
              />
            )
          ) : attributes.type == "number_format" ? (
            <NumberFormat
              value={attributes.value}
              thousandSeparator={true}
              prefix={attributes?.prefix}
              format={attributes?.format}
              onChange={attributes.onChange}
              onValueChange={(values, sourceInfo) => {
                const { formattedValue, value } = values;
                // Event is a Synthetic Event wrapper which holds target and other information. Source tells whether the reason for this function being triggered was an 'event' or due to a 'prop' change
                const { event, source } = sourceInfo;
                attributes.onChange(values.value);
              }}
            />
          ) : (
            <input
              type={attributes.type}
              className={`form-control ${attributes.errorClass ? "is-invalid" : ""
                }  ${attributes?.native && "fileUpload"} inputCustom ${attributes.className ? attributes.className : ""
                } file`}
              name={attributes.name}
              disabled={attributes.disabled}
              multiple={attributes?.multiple}
              value={attributes.value}
              capture={attributes?.capture}
              accept={attributes.accept}
              onChange={attributes.onChange}
            />
          )}

          {/* {attributes?.type==="file" && attributes?.native && (
            <div class="divButton">{attributes?.placeholder?attributes.placeholder:'Click here to select your files'}</div>
          )}
           */}
        </div>
        {attributes?.type != "file" && !attributes?.native && (
          <label
            htmlFor={`${attributes.name}`}
            className={`${attributes.value && "filled"} ${attributes.type == "file" ? "file" : ""
              }`}
          >
            {attributes.placeholder}
          </label>
        )}
        <div
          className={`invalid-feedback ${attributes.errorClass ? "is-invalid-show" : ""
            }`}
        >
          {attributes.errorMessage}
        </div>
      </div>
    );
  }
}

export default Input;
